import React from 'react';
import { Tag, Tooltip } from 'antd';
import { MaskRestrictedText } from '_src/components';

export default [
  {
    title: 'First name',
    dataIndex: 'firstName',
    key: 'firstName',
    render: (_, { firstName }) => <div>{firstName}</div>,
    sorter: true,
    width: 200
  },
  {
    title: 'Last name',
    dataIndex: 'lastName',
    key: 'lastNAme',
    render: (_, { lastName }) => <div> {lastName}</div>,
    sorter: true,
    width: 200
  },
  {
    title: 'Contact number',
    dataIndex: 'contactNumber',
    width: 150
  },
  {
    title: 'Branch name',
    dataIndex: 'branchName',
    sorter: true,
    width: 180,
    render: (_, { branchName }) => <div style={{ whiteSpace: 'break-spaces' }}>{branchName}</div>
  },
  {
    title: 'Location type',
    dataIndex: 'locationType',
    width: 120
  },
  {
    title: 'Sponsor',
    dataIndex: 'sponsor',
    sorter: true,
    width: 200,
    render: sponsors => {
      const sponsorsList = sponsors ? sponsors.split(';').map(s => s.trim()) : [];
      return (
        <MaskRestrictedText
          text={
            <Tooltip
              placement="bottom"
              title={
                <div style={{ padding: 10 }}>
                  {sponsorsList.map(sponsor => (
                    <Tag color="blue" key={sponsor} style={{ marginBottom: 5, display: 'block' }}>
                      {sponsor}
                    </Tag>
                  ))}
                </div>
              }
            >
              <div style={{ display: 'flex' }}>
                <span
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 200
                  }}
                >
                  {sponsorsList[0]}
                </span>
                {sponsorsList.length > 1 && (
                  <span style={{ cursor: 'pointer', color: '#1890ff' }}>
                    {' '}
                    &nbsp;+{sponsorsList.length - 1}
                  </span>
                )}
              </div>
            </Tooltip>
          }
        />
      );
    }
  },
  {
    title: 'Pre-Trip (State/AAMVA Testing Use ONLY)',
    children: [
      {
        title: 'Completion',
        dataIndex: 'preTripCompletion',
        width: 120
      },
      {
        title: 'Performance',
        dataIndex: 'preTripPerformance',
        width: 120
      },
      {
        title: 'Last evaluation date',
        dataIndex: 'lastPretripEvaluationDate',
        width: 170,
        render: (_, { lastPretripEvaluationDate }) => (
          <div style={{ whiteSpace: 'break-spaces' }}>{lastPretripEvaluationDate}</div>
        )
      }
    ]
  },
  {
    title: 'Total Pre-Trip (State/AAMVA Testing Use ONLY) hours',
    dataIndex: 'totalPreTripHours',
    width: 220
  },
  {
    title: 'BTW—Public Road',
    children: [
      {
        title: 'Completion',
        dataIndex: 'roadCompletion',
        width: 120
      },
      {
        title: 'Performance',
        dataIndex: 'roadPerformance',
        width: 120
      },
      {
        title: 'Last evaluation date',
        dataIndex: 'lastRoadEvaluationDate',
        width: 170,
        render: (_, { lastRoadEvaluationDate }) => (
          <div style={{ whiteSpace: 'break-spaces' }}>{lastRoadEvaluationDate}</div>
        )
      }
    ]
  },
  {
    title: 'Total BTW—Public Road observation hours',
    dataIndex: 'totalRoadObservationHours',
    width: 190
  },
  {
    title: 'Total BTW—Public Road hours',
    dataIndex: 'totalRoadHours',
    width: 170
  },
  {
    title: 'BTW—Range',
    children: [
      {
        title: 'Completion',
        dataIndex: 'skillsCompletion',
        width: 120
      },
      {
        title: 'Performance',
        dataIndex: 'skillsPerformance',
        width: 120
      },
      {
        title: 'Last evaluation date',
        dataIndex: 'lastSkillsEvaluationDate',
        width: 170,
        render: (_, { lastSkillsEvaluationDate }) => (
          <div style={{ whiteSpace: 'break-spaces' }}>{lastSkillsEvaluationDate}</div>
        )
      }
    ]
  },
  {
    title: 'Total BTW—Range observation hours',
    dataIndex: 'totalSkillObservationHours',
    width: 180
  },
  {
    title: 'Total BTW—Range hours',
    dataIndex: 'totalSkillHours',
    width: 160
  },
  {
    title: 'Total class hours',
    dataIndex: 'totalClassHours',
    width: 140
  },
  {
    title: 'Total training hours',
    dataIndex: 'totalTrainingHours',
    width: 150
  }
];
